import { Router } from "./Router";
import { RouterProps } from "./RouterProps";

export class WebRouter extends Router {
    constructor(props: Partial<RouterProps>) {
        super(props);
    }

    static get instance(): WebRouter {
        if (Router.instance == null)
            new WebRouter({}); // The parent will set its own ._instance value.
        return Router.instance as WebRouter;
    }
}
